<template>
  <div class="container mt-5">
    <div class="row justify-content-center mt-5">
      <img src="@/assets/images/Hotel/img_ok.png" height="180" alt="" />
    </div>
    <div v-if="isLogin" class="mt-5 text-center">
      <div class="completeInfo">예약이 완료되었습니다.</div>
      <div class="completeInfo">마이페이지에서 접수내용을 확인하실 수 있습니다.</div>
    </div>
    <div v-else class="mt-5 text-center">
      <div class="completeInfo">비회원 예약이 완료되었습니다.</div>
      <div class="completeInfo">예약번호: {{ reservNo }}</div>
      <div class="completeResNum">비회원 예약확인에서 예약내용을 확인하실 수 있습니다.</div>
    </div>
    <div class="row justify-content-center my-3">
      <b-button class="confirmButton p-3" :to="reservQueryLink" variant="primary"> 예약내역 확인 </b-button>
    </div>
  </div>
</template>

<script>
import {hotelName} from '@/pages/Reservation/hotelType';
export default {
  name: 'ReceiptStage3',
  props: {
    reservNo: String,
  },
  data() {
    return {
      hotelName: hotelName,
    };
  },
  computed: {
    isLogin() {
      return this.$store.getters['Auth/isLoggedIn'];
    },
    reservQueryLink() {
      if (this.isLogin) {
        return {name: 'MyPage', params: {reservCategory: hotelName}};
      } else {
        return {name: 'GuestReservResult', params: {reservNo: this.reservNo}};
      }
    },
  },
};
</script>

<style scoped lang="scss">
.completeInfo {
  font-size: 1rem;
}
.completeResNum {
  margin: 1rem;
  font-size: 1.1rem;
  font-weight: bold;
}
@media (min-width: 992px) {
  .confirmButton {
    width: 25%;
  }
}
@media (max-width: 992px) {
  .confirmButton {
    width: 50%;
  }
}
</style>
